import tw, { styled } from 'twin.macro'
import { Link } from 'gatsby'

const navbarLinkTemplate = tw`mx-3 my-4 lg:my-0 block lg:inline-block text-gray-700 hover:text-red-500 no-underline border-none font-light cursor-pointer font-sans text-base xl:text-lg`

const NavbarLink = styled(Link)`
  ${navbarLinkTemplate}
`

export const navbarLinkStyles = navbarLinkTemplate;

export default NavbarLink;
